function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { imgPasswordInVisible, imgPasswordVisible } from "./assets";
// Customizable Area End

export const configJSON = require("./config");
export default class EmailAccountRegistrationController extends BlockComponent {
  // Customizable Area End

  constructor(props) {
    super(props);
    // Customizable Area Start
    _defineProperty(this, "validationApiCallId", "");
    _defineProperty(this, "imgEnableRePasswordFieldProps", {
      source: imgPasswordVisible
    });
    _defineProperty(this, "btnConfirmPasswordShowHideProps", {
      onPress: () => {
        this.setState({
          enableReTypePasswordField: !this.state.enableReTypePasswordField
        });
        this.txtInputConfirmPasswordProps.secureTextEntry = !this.state.enableReTypePasswordField;
        this.imgEnableRePasswordFieldProps.source = this.txtInputConfirmPasswordProps.secureTextEntry ? imgPasswordVisible : imgPasswordInVisible;
      }
    });
    _defineProperty(this, "imgEnablePasswordFieldProps", {
      source: imgPasswordVisible
    });
    _defineProperty(this, "btnPasswordShowHideProps", {
      onPress: () => {
        this.setState({
          enablePasswordField: !this.state.enablePasswordField
        });
        this.txtInputPasswordProps.secureTextEntry = !this.state.enablePasswordField;
        this.imgEnablePasswordFieldProps.source = this.txtInputPasswordProps.secureTextEntry ? imgPasswordVisible : imgPasswordInVisible;
      }
    });
    _defineProperty(this, "btnSignUpProps", {
      onPress: () => this.createAccount()
    });
    _defineProperty(this, "btnLegalPrivacyPolicyProps", {
      onPress: () => this.goToPrivacyPolicy()
    });
    _defineProperty(this, "btnLegalTermsAndConditionProps", {
      onPress: () => this.goToTermsAndCondition()
    });
    _defineProperty(this, "txtInputEmailWebPrpos", {
      onChangeText: text => {
        this.setState({
          email: text
        });
        //@ts-ignore
        this.txtInputEmailPrpos.value = text;
      }
    });
    _defineProperty(this, "txtInputEmailMobilePrpos", _objectSpread(_objectSpread({}, this.txtInputEmailWebPrpos), {}, {
      keyboardType: "email-address"
    }));
    _defineProperty(this, "txtInputEmailPrpos", this.isPlatformWeb() ? this.txtInputEmailWebPrpos : this.txtInputEmailMobilePrpos);
    _defineProperty(this, "txtPhoneNumberWebProps", {
      onChangeText: text => {
        this.setState({
          phone: text
        });

        //@ts-ignore
        this.txtPhoneNumberProps.value = text;
      }
    });
    _defineProperty(this, "txtPhoneNumberMobileProps", _objectSpread(_objectSpread({}, this.txtPhoneNumberWebProps), {}, {
      autoCompleteType: "tel",
      keyboardType: "phone-pad"
    }));
    _defineProperty(this, "txtPhoneNumberProps", this.isPlatformWeb() ? this.txtPhoneNumberWebProps : this.txtPhoneNumberMobileProps);
    _defineProperty(this, "txtInputLastNamePrpos", {
      onChangeText: text => {
        this.setState({
          lastName: text
        });

        //@ts-ignore
        this.txtInputLastNamePrpos.value = text;
      }
    });
    _defineProperty(this, "txtInputFirstNamePrpos", {
      onChangeText: text => {
        this.setState({
          firstName: text
        });

        //@ts-ignore
        this.txtInputFirstNamePrpos.value = text;
      }
    });
    _defineProperty(this, "txtInputConfirmPasswordProps", {
      onChangeText: text => {
        this.setState({
          reTypePassword: text
        });

        //@ts-ignore
        this.txtInputConfirmPasswordProps.value = text;
      },
      secureTextEntry: true
    });
    _defineProperty(this, "txtInputPasswordProps", {
      onChangeText: text => {
        this.setState({
          password: text
        });

        //@ts-ignore
        this.txtInputPasswordProps.value = text;
      },
      secureTextEntry: true
    });
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage), getName(MessageEnum.NavigationPayLoadMessage), getName(MessageEnum.CountryCodeMessage)];
    this.receive = this.receive.bind(this);
    this.isStringNullOrBlank = this.isStringNullOrBlank.bind(this);
    runEngine.attachBuildingBlock(this, this.subScribedMessages);
    this.state = {
      // Customizable Area Start
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      reTypePassword: "",
      otpAuthToken: "",
      data: [],
      passwordHelperText: "",
      enablePasswordField: true,
      enableReTypePasswordField: true,
      countryCodeSelected: "",
      phone: ""
      // Customizable Area End
    };

    // Customizable Area Start
    this.arrayholder = [];
    this.passwordReg = new RegExp("\\w+");
    this.emailReg = new RegExp("\\w+");
    this.imgPasswordVisible = imgPasswordVisible;
    this.imgPasswordInVisible = imgPasswordInVisible;
    this.labelHeader = configJSON.labelHeader;
    this.labelFirstName = configJSON.labelFirstName;
    this.lastName = configJSON.lastName;
    this.labelEmail = configJSON.labelEmail;
    this.labelPassword = configJSON.labelPassword;
    this.labelRePassword = configJSON.labelRePassword;
    this.labelLegalText = configJSON.labelLegalText;
    this.labelLegalTermCondition = configJSON.labelLegalTermCondition;
    this.labelLegalPrivacyPolicy = configJSON.labelLegalPrivacyPolicy;
    this.btnTextSignUp = configJSON.btnTextSignUp;
    // Customizable Area End
  }
  async receive(from, message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
      if (apiRequestCallId && responseJson) {
        if (apiRequestCallId === this.validationApiCallId) {
          this.arrayholder = responseJson.data;
          if (this.arrayholder && this.arrayholder.length !== 0) {
            let regexData = this.arrayholder[0];
            if (regexData.password_validation_regexp) {
              this.passwordReg = new RegExp(regexData.password_validation_regexp);
            }
            if (regexData.password_validation_rules) {
              this.setState({
                passwordHelperText: regexData.password_validation_rules
              });
            }
            if (regexData.email_validation_regexp) {
              this.emailReg = new RegExp(regexData.email_validation_regexp);
            }
          }
        } else if (apiRequestCallId === this.createAccountApiCallId) {
          if (!responseJson.errors) {
            const msg = new Message(getName(MessageEnum.AccoutResgistrationSuccess));
            msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
            this.send(msg);
          } else {
            //Check Error Response
            this.parseApiErrorResponse(responseJson);
          }
          this.parseApiCatchErrorResponse(errorReponse);
        }
      }
    }
    if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      const otpAuthTkn = message.getData(getName(MessageEnum.AuthTokenDataMessage));
      if (otpAuthTkn && otpAuthTkn.length > 0) {
        this.setState({
          otpAuthToken: otpAuthTkn
        });
        runEngine.debugLog("otpAuthTkn", this.state.otpAuthToken);
        runEngine.unSubscribeFromMessages(this, [message.id]);
      }
    }
    if (getName(MessageEnum.CountryCodeMessage) === message.id) {
      var selectedCode = message.getData(getName(MessageEnum.CountyCodeDataMessage));
      if (selectedCode !== undefined) {
        this.setState({
          countryCodeSelected: selectedCode.indexOf("+") > 0 ? selectedCode.split("+")[1] : selectedCode
        });
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  goToPrivacyPolicy() {
    const msg = new Message(getName(MessageEnum.NavigationPrivacyPolicyMessage));
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }
  goToTermsAndCondition() {
    const msg = new Message(getName(MessageEnum.NavigationTermAndConditionMessage));
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }
  isStringNullOrBlank(str) {
    return str === null || str.length === 0;
  }
  isValidEmail(email) {
    return this.emailReg.test(email);
  }
  createAccount() {
    if (this.isStringNullOrBlank(this.state.firstName) || this.isStringNullOrBlank(this.state.lastName) || this.isStringNullOrBlank(this.state.email) || this.isStringNullOrBlank(this.state.password) || this.isStringNullOrBlank(this.state.reTypePassword)) {
      this.showAlert(configJSON.errorTitle, configJSON.errorAllFieldsAreMandatory);
      return false;
    }
    var phoneNumberError = this.validateCountryCodeAndPhoneNumber(this.state.countryCodeSelected, this.state.phone);
    if (phoneNumberError) {
      this.showAlert(configJSON.errorTitle, phoneNumberError);
      return false;
    }
    if (!this.isValidEmail(this.state.email)) {
      this.showAlert(configJSON.errorTitle, configJSON.errorEmailNotValid);
      return false;
    }
    if (!this.passwordReg.test(this.state.password)) {
      this.showAlert(configJSON.errorTitle, configJSON.errorPasswordNotValid);
      return false;
    }
    if (this.state.password !== this.state.reTypePassword) {
      this.showAlert(configJSON.errorTitle, configJSON.errorBothPasswordsNotSame);
      return false;
    }
    const header = {
      "Content-Type": configJSON.contentTypeApiAddDetail
    };
    const attrs = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      email: this.state.email,
      password: this.state.password,
      full_phone_number: "+" + this.state.countryCodeSelected + this.state.phone
    };
    const data = {
      type: "email_account",
      attributes: attrs
    };
    const httpBody = {
      data: data,
      token: this.state.otpAuthToken
    };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.createAccountApiCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.accountsAPiEndPoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.apiMethodTypeAddDetail);
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }
  getValidations() {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };
    const getValidationsMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.validationApiCallId = getValidationsMsg.messageId;
    getValidationsMsg.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.urlGetValidations);
    getValidationsMsg.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(headers));
    getValidationsMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.validationApiMethodType);
    runEngine.sendMessage(getValidationsMsg.id, getValidationsMsg);
  }
  isNonNullAndEmpty(value) {
    return value !== undefined && value !== null && value !== "null" && value.trim().length > 0;
  }
  validateCountryCodeAndPhoneNumber(countryCode, phoneNumber) {
    let error = null;
    if (this.isNonNullAndEmpty(phoneNumber)) {
      if (!this.isNonNullAndEmpty(String(countryCode))) {
        error = configJSON.errorCountryCodeNotSelected;
      }
    } else if (this.isNonNullAndEmpty(countryCode)) {
      if (!this.isNonNullAndEmpty(phoneNumber)) {
        error = "Phone " + configJSON.errorBlankField;
      }
    }
    return error;
  }

  // Customizable Area End
}